import { PER_PAGE_OPTIONS } from '@keen.io/ui-core';
var transform = {
  serializeIn: function serializeIn(settings) {
    var formatValue = settings.formatValue,
        columnsNamesMapping = settings.columnsNamesMapping,
        rowsSelection = settings.rowsSelection,
        _settings$pagination = settings.pagination,
        pagination = _settings$pagination === void 0 ? true : _settings$pagination,
        _settings$rowsPerPage = settings.rowsPerPage,
        rowsPerPage = _settings$rowsPerPage === void 0 ? PER_PAGE_OPTIONS[3] : _settings$rowsPerPage;
    return {
      formatTableColumns: formatValue || {},
      columnsNamesMapping: columnsNamesMapping || {},
      rowsSelection: rowsSelection,
      pagination: pagination,
      rowsPerPage: rowsPerPage
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatTableColumns = _ref.formatTableColumns,
        columnsNamesMapping = _ref.columnsNamesMapping,
        rowsSelection = _ref.rowsSelection,
        pagination = _ref.pagination,
        rowsPerPage = _ref.rowsPerPage;
    return {
      formatValue: formatTableColumns,
      columnsNamesMapping: columnsNamesMapping,
      rowsSelection: rowsSelection,
      pagination: pagination,
      rowsPerPage: rowsPerPage
    };
  }
};
export default transform;